import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { collection, deleteDoc, doc, onSnapshot, query, setDoc, where, serverTimestamp } from 'firebase/firestore';

const LikeButton = ({ imageKey }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const makeSafeId = (key, uid) => {
    // Avoid slashes in doc IDs; use a simple stable hash
    let hash = 5381;
    for (let i = 0; i < key.length; i += 1) {
      hash = ((hash << 5) + hash) + key.charCodeAt(i);
      hash &= 0xffffffff;
    }
    return `img_${(hash >>> 0).toString(16)}__${uid}`;
  };
  const likeDocId = user ? makeSafeId(imageKey, user.uid) : null;

  useEffect(() => {
    setLoading(true);
    const likesCol = collection(db, 'imageLikes');
    const qCount = query(likesCol, where('imageKey', '==', imageKey));
    const unsubCount = onSnapshot(qCount, (snap) => {
      setCount(snap.size);
      setLoading(false);
    });
    let unsubMine = () => {};
    if (user) {
      const qMine = query(likesCol, where('imageKey', '==', imageKey), where('userId', '==', user.uid));
      unsubMine = onSnapshot(qMine, (snap) => {
        setLiked(!snap.empty);
      });
    } else {
      setLiked(false);
    }
    return () => {
      unsubCount();
      unsubMine();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageKey, user?.uid]);

  const toggle = async () => {
    if (!user) {
      navigate('/login');
      return;
    }
    const likesCol = collection(db, 'imageLikes');
    const likeRef = doc(likesCol, likeDocId);
    if (liked) {
      await deleteDoc(likeRef);
      setLiked(false);
      setCount((c) => Math.max(0, c - 1));
    } else {
      await setDoc(likeRef, { imageKey, userId: user.uid, createdAt: serverTimestamp() });
      setLiked(true);
      setCount((c) => c + 1);
    }
  };

  return (
    <button type="button" className={`like-button ${liked ? 'liked' : ''}`} onClick={toggle} disabled={loading} aria-label="Like this painting">
      <svg className="like-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12.001 4.529c2.349-2.532 6.15-2.532 8.498 0 2.348 2.531 2.348 6.635 0 9.166l-6.819 7.354a2.5 2.5 0 0 1-3.358 0l-6.82-7.354c-2.347-2.531-2.347-6.635 0-9.166 2.349-2.532 6.15-2.532 8.498 0Z" stroke="currentColor" strokeWidth="1.5" fill={liked ? 'currentColor' : 'none'} />
      </svg>
      <span className="like-count">{count}</span>
    </button>
  );
};

export default LikeButton;


